<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="pb-2">
    <div [hidden]="isLoading" class="col-md-10 offset-md-1 animate__animated animate__fadeIn">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item [aboutCardId]="43"></ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>

      @if (isHostedEnabled) {
        <ziro-saml-sso-type-form
          [entity]="samlConfig"
          (ziroFormsUpdate$)="onSsoTypeFormUpdate($event)"
        ></ziro-saml-sso-type-form>
      } @else {
        <div data-automation="saml-alert-text" class="alert alert-info">
          <span [innerHTML]="'tkey;admin.saml.alert.text' | escapeHtml"></span>
        </div>
      }

      <div class="mb-3 list-group border-rad-all-12 card-shadow">
        @if (!isHostedEnabled || samlConfig.ssoEnabled) {
          <div class="list-group-item">
            <h5>{{ 'tkey;admin.saml.sp.title' | translate }}</h5>
            <div class="row">
              <div class="col-lg-7">
                <p [innerHTML]="'tkey;admin.saml.sp.description' | escapeHtml"></p>
              </div>
              <div class="col-lg-5">
                <div class="align-items-center d-md-flex justify-content-end d-block">
                  @if (samlSpMetaDataTimestamp.timestamp && samlSpDate) {
                    <p class="animate__animated animate__fadeIn m-0 p-1 pe-3">
                      <i [class]="ziroIcons.TIMESTAMP"></i>
                      <span class="ms-1" data-automation="saml-sp-timestamp">
                        {{ 'tkey;admin.saml.timestamp.label.exported' | translate }}
                        <span class="fw-bold">{{ samlSpDate | date }}</span>
                      </span>
                    </p>
                  }
                  <div class="d-flex flex-column justify-content-between">
                    <ziro-saml-export-btn
                      [label]="'tkey;admin.saml.button.sp.export'"
                      [dataAutomation]="'saml-sp-export-btn'"
                      [icon]="ziroIcons.EXPORT"
                      [event]="samlSpGetMetadataXML"
                    ></ziro-saml-export-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="list-group-item bg-light"
            [ngClass]="{ 'has-error': isSubmitted && !samlIdpMetaDataTimestamp.timestamp }"
          >
            <h5>{{ 'tkey;admin.saml.idp.title' | translate }}</h5>
            <div class="row">
              <div class="col-lg-7">
                <p [innerHTML]="'tkey;admin.saml.idp.description' | escapeHtml"></p>
              </div>
              <div class="col-lg-5">
                <div class="align-items-center d-md-flex justify-content-end d-block">
                  @if (samlIdpMetaDataTimestamp.timestamp && samlIdpDate) {
                    <p class="animate__animated animate__fadeIn m-0 p-1 pe-3">
                      <i [class]="ziroIcons.TIMESTAMP"></i>
                      <span class="ms-1" data-automation="saml-idp-timestamp">
                        {{ 'tkey;admin.saml.timestamp.label.imported' | translate }}
                        <span class="fw-bold">{{ samlIdpDate | date }}</span>
                      </span>
                    </p>
                  }
                  <div class="d-flex flex-column justify-content-between">
                    <ziro-saml-import-btn
                      class="mb-1"
                      [label]="'tkey;admin.saml.button.idp.import'"
                      [dataAutomation]="'saml-idp-import-btn'"
                      [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                      [uploadEvent]="samlIdpUpload"
                      [fileExtension]="'.xml'"
                      [icon]="ziroIcons.IMPORT"
                      [iconPending]="ziroIcons.SAVING"
                      (successfulImport)="handleSuccessfulFileImport()"
                      (invalidTypeError)="handleInvalidImportTypeError()"
                    ></ziro-saml-import-btn>
                    @if (isSubmitted && !samlIdpMetaDataTimestamp.timestamp) {
                      <span class="small strong mb-2" data-automation="saml-idp-import-btn-error">
                        {{ 'tkey;admin.saml.button.idp.import.required' | translate }}
                      </span>
                    }
                    <ziro-saml-export-btn
                      [label]="'tkey;admin.saml.button.idp.export'"
                      [dataAutomation]="'saml-idp-export-btn'"
                      [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                      [icon]="ziroIcons.EXPORT"
                      [isDisabled]="!samlIdpMetaDataTimestamp.timestamp"
                      [ngbTooltip]="'tkey;admin.saml.idp.export.tooltip' | translate"
                      [disableTooltip]="!!samlIdpMetaDataTimestamp.timestamp"
                      [event]="!samlIdpMetaDataTimestamp.timestamp ? null : samlIdpGetMetadataXML"
                    ></ziro-saml-export-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (!isHostedEnabled) {
          <div class="list-group-item">
            <div class="row py-2">
              <div class="col-md-7">
                <h5>{{ 'tkey;admin.saml.sso.title' | translate }}</h5>
              </div>
              <div class="col-md-5">
                <div class="align-items-center d-md-flex justify-content-end d-block">
                  <div
                    data-automation="sso-toggle-input"
                    class="form-check form-switch switch-lg"
                    [placement]="'top'"
                    [disableTooltip]="
                      !!(
                        samlConfig.ssoEnabled ||
                        (samlSpMetaDataTimestamp.timestamp && samlIdpMetaDataTimestamp.timestamp)
                      )
                    "
                    [ngbTooltip]="'tkey;admin.saml.sso.tooltip' | translate"
                  >
                    <input
                      [(ngModel)]="samlConfig.ssoEnabled"
                      (change)="onEnabledToggled()"
                      [disabled]="
                        !(
                          samlConfig.ssoEnabled ||
                          (samlSpMetaDataTimestamp.timestamp && samlIdpMetaDataTimestamp.timestamp)
                        )
                      "
                      data-automation="ziro-checkbox-input"
                      type="checkbox"
                      class="form-check-input"
                      id="enhancedLineModeToggle"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
